import React from "react";
import { useTranslation } from "react-i18next";

const Privacypolicy = () => {
  const { t } = useTranslation();

  return (
    <main className="page-content">
      <div className="tm-about-area tm-padding-section bg-white">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="tm-about-content">
                <h4>{t("Privacypolicy")}</h4>
                <h6>{t("companyname")}</h6>
                <p>
                {t("pp1")}
                </p>
                <p>
                {t("pp2")}
                 
                </p>
                <h6> 
                {t("pp3")}

                </h6>
                <p>
                {t("pp4")}
                
                </p>
                <h6>
                {t("pp5")}

                </h6>
                <p>
                {t("pp6")}
                 
                </p>
                <h6>

                {t("pp7")}

                </h6>
                <p>
                {t("pp8")}

                </p>
                <h6>

                {t("pp9")}

                </h6>
                <p>
                {t("pp10")}
                 
                  <br />
                  {t("pp11")}
                
                </p>
                <h6>

                {t("pp12")}

                </h6>
                <p>
                {t("pp13")}
                
                </p>
                <h6>

                {t("pp14")}

                </h6>
                <p>
                {t("pp15")}
                 
                  <br />
                {t("pp16")}
                 
                  <br />
                  {t("pp17")}
                
                </p>
                <h6>

                {t("pp18")}

                </h6>
                <p>
                {t("pp19")}
                 
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Privacypolicy;
